import type { TxnStatus } from "@shared/types";

/** Render integer cents as a localized currency string. */
export function formatCents(cents: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format((cents ?? 0) / 100);
}

/** Parse a user-entered dollar string (e.g. "19.99") into integer cents. */
export function dollarsToCents(input: string | number): number {
  const n = typeof input === "number" ? input : parseFloat(input);
  if (!isFinite(n)) return 0;
  return Math.round(n * 100);
}

/** Cents → editable dollar string. */
export function centsToDollars(cents: number): string {
  return ((cents ?? 0) / 100).toFixed(2);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  if (!y) return iso;
  return new Date(Number(y), Number(m) - 1, Number(d)).toLocaleDateString(
    "en-US",
    { year: "numeric", month: "short", day: "numeric" },
  );
}

export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

export function yearStart(): string {
  return `${new Date().getFullYear()}-01-01`;
}

const STATUS_STYLES: Record<string, string> = {
  draft: "bg-gray-100 text-gray-700",
  open: "bg-blue-100 text-blue-700",
  partial: "bg-amber-100 text-amber-700",
  paid: "bg-brand-100 text-brand-700",
  void: "bg-red-100 text-red-700",
};

export function statusStyle(status: TxnStatus | string): string {
  return STATUS_STYLES[status] ?? "bg-gray-100 text-gray-700";
}

export const ACCOUNT_TYPE_LABELS: Record<string, string> = {
  asset: "Assets",
  liability: "Liabilities",
  equity: "Equity",
  income: "Income",
  expense: "Expenses",
};
